// @flow
import React from 'react';

import { APP_ACCESS, APP_POLLS, APP_DNEVNIK, APP_CAFETERIA } from 'app/common/constants/services';

import {
  IconAppDining,
  IconAppPassages,
  IconAppBook,
  IconAppGradeBook,
} from 'app/components/_Icons';

import styles from './Icon.scss';


type Props = {
  service: string,
}

const Icon = ({ service }: Props) => {
  switch (service) {
    case APP_CAFETERIA: {
      return <IconAppDining className={styles.icon} />;
    }
    case APP_ACCESS: {
      return <IconAppPassages className={styles.icon} />;
    }
    case APP_POLLS: {
      return <IconAppBook className={styles.icon} />;
    }
    case APP_DNEVNIK: {
      return <IconAppGradeBook className={styles.icon} />;
    }
    default: {
      return <IconAppGradeBook className={styles.icon} />;
    }
  }
};

export default Icon;
